import type { AuditPageRequest } from '../models/paged-result';
import { buildPageRequest, DEFAULT_PAGE_SIZE, type GridFields, type GridState } from './grid-request';

/** The page size the Audit grid starts with; also the server's default. */
export const AUDIT_DEFAULT_PAGE_SIZE = DEFAULT_PAGE_SIZE;

/** The part of the grid's state the Audit page request is built from. */
export type AuditGridState = GridState;

/** Columns the server accepts for filtering, and how their values are written on the wire. */
const AUDIT_FIELDS: GridFields = {
    requestId: 'number',
    matterNo: 'number',
    amount: 'number',
    requestTypeName: 'text',
    stageName: 'text',
    approvalStatus: 'text',
    rpaStatus: 'text',
    matter: 'text',
    clientName: 'text',
    partnerName: 'text',
    createdByName: 'text',
    updatedByName: 'text',
    currencyCode: 'text',
    clientBankAccountName: 'text',
    rejectedReason: 'text',
    createdDate: 'date',
    updatedDate: 'date'
};

/** Builds the Audit page request from the grid's current paging, sorting and filter state. */
export function buildAuditPageRequest(state: AuditGridState): AuditPageRequest {
    return buildPageRequest(AUDIT_FIELDS, state);
}
